import Api from 'core/api';
import useMutation from 'hooks/useMutation';
import useRedirect from 'hooks/useRedirect';

const useSwitchUserMode = () => {
  const { redirect } = useRedirect();

  const { mutateAsync: updateCurrentUserMode } = useMutation({
    apiFunc: Api.slUsers.updateCurrentUserMode,
    onError: error => {
      console.error('Error updating current user mode', error.message);
    },
  });

  /**
   * @param {['secondary', 'guardian', 'elementary']} currentUserMode
   * @param {Object<{to: string, component: string, reason: string}>} redirectProps
   * @param {Boolean} reload
   * @returns {func} switchUserMode
   */
  const switchUserMode = async ({
    currentUserMode,
    redirectProps = undefined,
    reload = false,
  } = {}) => {
    await updateCurrentUserMode({
      payload: { currentUserMode },
    });
    if (reload) {
      return window.location.reload();
    }
    if (redirectProps) {
      return redirect(redirectProps);
    }
    return null;
  };

  return { switchUserMode };
};

export default useSwitchUserMode;
